import { memo } from "react";
import { GridActionsCellItem, type GridRowParams } from '@mui/x-data-grid-premium';
import type { User } from 'features/users/types';
import { ConfirmableAction } from "ui/molecules/Action";
import Icon from 'ui/atoms/Icon';
import useDeleteUser from "./useDeleteUser";
import DialogContent from "./DialogContent";

const DeleteUser = (props: GridRowParams<User>) => {
    const {
        renderLabel,
        getIsRowOwner,
        deleteUser
    } = useDeleteUser(props);

    const dialogContent = {
        dialogContent: [
            <DialogContent {...props} />
        ],
        actionContent: 'Delete user'
    };

    return (
        <GridActionsCellItem
            sx={{
                ml: -3,
                width: 30,
                height: 30,
                visibility: getIsRowOwner()
                    ? 'hidden'
                    : 'visible'
            }}
            label={renderLabel({
                prefix: 'Delete user'
            })}
            icon={(
                <ConfirmableAction
                    ActionProps={{
                        children: (
                            <Icon name='DeleteForever' />
                        ),
                        'data-test-id': `users.row.${props.row.coreId}.deleteUser`
                    }}
                    DialogProps={{
                        content: [
                            dialogContent,
                            dialogContent
                        ],
                        onConfirm: () => deleteUser(props.row.coreId),
                        checkPredicate: () => false,
                        onCancel: () => { },
                        cancelActionContentSlot: 'Cancel',
                        'data-test-id': `users.row.${props.row.coreId}.deleteUser.modal`
                    }}
                />
            )}
        />
    );
};

export default memo(DeleteUser);
